<div class="tabbable__body rounded-top-right no-margin">
  <h3 >
    Här kan du administrera hur estimaten ska räknas om till completed views
  </h3>


  @if (show.estimatesHaveChanged) {
    <import-warning></import-warning>
    <dot-loader [visibility]="show.updatingEstimates"></dot-loader>
  }

  <div class="container">
    <div class="left-item">
      @if (show.isEditing) {
        <button
          class="button primary"
          (click)="save()"
          [disabled]="completionRates.invalid"
        >
          Spara
        </button>
        <button class="link" (click)="cancelEditing()">
          Avbryt redigering
        </button>
      } @else {
        <button
          class="button primary"
          (click)="setEditing(true)"
        >
          Redigera completion rate
        </button>
      }
    </div>

    <div class="right-item">
        @if (publishers()?.length > 1) {
          <div class="filter-dropdown margin-left--2x">
            <woo-dropdown
              [items]="publishers()"
              [ngModel]="selectedPublisher()"
              (ngModelChange)="selectedPublisher.set($event)"
              name="selectedPublisher"
              inputId="select-publisher"
              labelText="Filtrera på Publicist"
              notFoundText="Inga publicister hittades."
              [clearable]="true"
            ></woo-dropdown>
          </div>
        }
    </div>
  </div>
  <div #stickyHeader class="sticky-background">
    <h3>Tillgängliga publicister</h3>
  </div>
  <app-woo-table [(data)]="completionRateRows" [debug]="false" ngForm #completionRates="ngForm" [loaderTpl]="loader">
    <column-parent [children]="['preroll','midroll','postroll','prerollSticky', 'postrollSticky']" title="Completion Rate"></column-parent>
    <woo-table-column header="Placering" name="publisher"></woo-table-column>
    <woo-table-column header="Preroll" name="preroll">
      <ng-template let-cell>
        <ng-container [ngTemplateOutlet]="percentCell" [ngTemplateOutletContext]="{ $implicit: cell }"></ng-container>
      </ng-template>
    </woo-table-column>
    <woo-table-column header="Midroll" name="midroll">
      <ng-template let-cell>
        <ng-container [ngTemplateOutlet]="percentCell" [ngTemplateOutletContext]="{ $implicit: cell }"></ng-container>
      </ng-template>
    </woo-table-column>
    <woo-table-column header="Postroll" name="postroll">
      <ng-template let-cell>
        <ng-container [ngTemplateOutlet]="percentCell" [ngTemplateOutletContext]="{ $implicit: cell }"></ng-container>
      </ng-template>
    </woo-table-column>
    <woo-table-column header="Preroll Sticky" name="prerollSticky">
      <ng-template let-cell>
        <ng-container [ngTemplateOutlet]="percentCell" [ngTemplateOutletContext]="{ $implicit: cell }"></ng-container>
      </ng-template>
    </woo-table-column>
    <woo-table-column header="Postroll Sticky" name="postrollSticky">
      <ng-template let-cell>
        <ng-container [ngTemplateOutlet]="percentCell" [ngTemplateOutletContext]="{ $implicit: cell }"></ng-container>
      </ng-template>
    </woo-table-column>

  </app-woo-table>
 
  <ng-template #loader let-data>
    <div class="text-center w-100">
      @if(show.loading) {
        <dot-loader [large]="true"></dot-loader>
      } @else {
        <span>Ingen data tillgänglig</span>
      }
    </div>
  </ng-template>

  @if (show.isEditing) {
    <div class="margin-top--2x">
      <button
        class="button primary"
        (click)="save()"
        [disabled]="completionRates.invalid"
      >
        Spara
      </button>
      <button class="link" (click)="cancelEditing()">
        Avbryt redigering
      </button>
    </div>
  }
</div>

<ng-template #percentCell let-cell>
  @if (show.isEditing) {
    <ng-container [ngTemplateOutlet]="percentEditor" [ngTemplateOutletContext]="{ $implicit: cell, key: cell.columnKey }"></ng-container>
  } @else {
    <span>{{ (cell.value | percent) ?? '-' }}</span>
  }
</ng-template>

<ng-template #percentEditor let-cell let-key="key">
  <div class="input__container in">
    <input
      class="w-full"
      [name]="'row-' + cell.index + '-' + key"
      [ngModel]="$any(cell.row)[key]"
      (ngModelChange)="cell.setCell(cell.row, key, $event)"
      wooPercentFormatter
      [wooMinValidator]="0"
      [wooMaxValidator]="1"
      [required]="includedPublisherSlotTypes[cell.row.publisherId][key]"
      [disabled]="!includedPublisherSlotTypes[cell.row.publisherId][key]"
    />
  </div>
</ng-template>